import { rateTableSchema } from "@redotech/redo-model/rate-table/rate-table";
import * as z from "zod/v4";

export const getTeamRateTables = {
  name: "getTeamRateTables" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ rateTables: z.array(rateTableSchema) }),
};
